import React from 'react';
import { Box, Text } from '@mantine/core';

const LineChangesTab = ({ selectedLineId }) => {
  return (
    <Box p="md">
      <Text>Line Changes tab content for Line {selectedLineId} - to be implemented</Text>
    </Box>
  );
};

export default LineChangesTab;